module.exports = __webpack_public_path__ + "static/media/bh.7510653e.svg";